export const UPLOAD_CONFIG = {
  maxSize: 15000000,
  acceptFormat: {
    "text/csv": [".csv"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  },
}

export const SKILL_UPLOAD_CONFIG = {
  maxSize: 5 * 1024 * 1024,
  maxUncompressedTotalBytes: 50 * 1024 * 1024,
  acceptFormat: {
    "application/zip": [".zip", ".skill"],
    "application/x-zip-compressed": [".zip"],
  },
}
